<template>
    <div>
        <div class="brdr_box_w_checkbox">
            <div class="r_country">
                <div class="r_country_row">
                    <label class="switch_checkbox_item">
                        <input type="checkbox" :checked="appConfig['r_to_country']" @change="$emit('update', $event.target.checked, 'r_to_country')">
                        <div class="switch_checkbox"><span></span></div>
                    </label>
                    <h3>Restrict suggestions to a country
	                    <info-icon>
		                    When targeting a single country it's better to restrict address suggestions which makes them more accurate.
	                    </info-icon>
                    </h3>
                </div>
                <div class="right w100" v-if="appConfig['r_to_country']">
                  <label>Restriction country</label>
	                <v-select :searchable="true"
	                          :clearable="true"
	                          label="text"
	                          :reduce="x => x.id"
	                          :value="appConfig['r_country']"
	                          v-model="appConfig['r_country']"
	                          :options="countries"/>
                </div>
            </div>
        </div>

        <div class="brdr_box_w_checkbox">
            <label class="switch_checkbox_item">
                <input type="checkbox"
                    :checked="appConfig['allow_default_autocomplete']"
                    @change="$emit('update', $event.target.checked, 'allow_default_autocomplete')"
                >
                <div class="switch_checkbox"><span></span></div>
            </label>
            <h3>Allow browser default auto-complete
	            <info-icon>
		            Whether or not to allow the browser to show it's default autocomplete options which might hide our smart address suggestions on some devices.
	            </info-icon>
            </h3>
        </div>
    </div>
</template>

<script>
import countries from "@/helpers/countries"
import Tooltip from "@/components/Tooltip.vue"
import InfoIcon from "@/components/base/info-icon";
export default {
    name: 'SmartAddress',
    props: ['dataBufferObject'],
    components: {
	    InfoIcon,
        Tooltip
    },
    data() {
        return {
            countries: countries,
            appConfig: {}
        }
    },
    created(){
        if(this.dataBufferObject) {
            this.appConfig = this.dataBufferObject;
            if (!this.appConfig.r_to_country) this.$set(this.appConfig, "r_to_country", false);
        } else {
            this.appConfig = {"r_to_country":false,"allow_default_autocomplete":false,"r_country":""}
        }
    }
}
</script>
